import 'babel-polyfill';
import React, { Component } from 'react';
import Start from './components/Start';
import Quiz from './components/Quiz';
import Result from './components/Result';
import Preload from './components/Preload';
import { shuffleArray, getJson } from './helpers'; // eslint-disable-line no-unused-vars
import axios from 'axios';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import loadinggif from './images/loading.gif' // relative path to image
const ReactGA = require('react-ga');

const windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
const bgSwitchBreakpoint = 376; // based on _variables.scss $breakpoint-bgswitch

class App extends Component {

  constructor(props) {
    super(props);
    this.state = {
      disableContinue: true
    };

    this.handleAnswerSelected = this.handleAnswerSelected.bind(this);
    this.handleClickContinue = this.handleClickContinue.bind(this);
    this.handleClickRestart = this.handleClickRestart.bind(this);
    this.handleClickStart = this.handleClickStart.bind(this);
  }

  componentDidMount() {
    setTimeout(function(){
        window.scrollTo(0, 1); // Hide the address bar!
      }, 0);

    axios.all( [getJson('./data/quizConfig.json'), getJson('./data/quizQuestions.json'), getJson('./data/quizStrings.json')] )
      .then( axios.spread( (_config, _questions, _strings) => {
        if( _config.data.quizConfig.shuffleQuestions ){
          this.quizQuestions = shuffleArray( _questions.data.quizQuestions );
        } else {
          this.quizQuestions = _questions.data.quizQuestions; // all questions unshuffled
        }

        // this.quizQuestions = _questions.data.quizQuestions.slice(0, 2); // limit to 2 questions for testing

        ReactGA.initialize( _config.data.quizConfig.googleAnalytics, { debug: false } );
        ReactGA.event({
          category: 'User',
          action: 'Quiz loaded',
          nonInteraction: true
        });

        this.quizStrings = _strings.data.quizStrings;

        this.setState({
          answerOptions: this.quizStrings.questions.answers,
          questionNumber: 1,
          questionIntro: this.quizQuestions[0].questionIntro,
          questionType: this.quizQuestions[0].questionType,
          subQuestions: this.quizQuestions[0].subQuestions,
          disableAnswerButtons: false,
          userAnswers: ['', '', ''],
          userAnswersCorrect: [null, null, null],
          score: 0,
          screen: 'start'
        });

        this.preloadQuestionImage( 0 );

      }))
      .catch( error => {
        console.log(error);
      });
  }

  handleAnswerSelected(subQuestionNumber, event) {
    // remember situation before new answer was given
    const oldUserAnswers = this.state.userAnswers.slice();
    if( oldUserAnswers[subQuestionNumber] === event.currentTarget.value ){
      return;
    }

    // set new answer
    this.setUserAnswer(subQuestionNumber, event.currentTarget.value);
    const duplicateAnswer = oldUserAnswers.indexOf( event.currentTarget.value );

    // was newly selected answer already given before for a different subquestion?
    if( duplicateAnswer !== -1){

      // yes, so lets change that previous answer
      // swap to next unused answer, if available
      let freeAnswer = -1;
      this.state.answerOptions.every( (answerOption, index) => {
        // console.log('check ' + answerOption.answer )
        const inSubQuestion = this.state.userAnswers.indexOf( answerOption.answer );
        // console.log( 'inSubQuestion ' + index + '? ' + inSubQuestion );
        if( inSubQuestion !== -1 ){
          return true;
        } else {
          freeAnswer = index;
          return false; //break every
        }
      });

      // if all answers have already been chosen, lets swap with the newly given answer
      if( freeAnswer === -1 ) freeAnswer = duplicateAnswer;
      this.setUserAnswer(duplicateAnswer, this.state.answerOptions[freeAnswer].answer);
    }
  }

  setUserAnswer(number, answer) {
    const userAnswers = this.state.userAnswers;
    userAnswers[number] = answer;

    this.setState({
      userAnswers: userAnswers
    });
  }

  increaseScore( points ) {
    const score = this.state.score + points;
    this.setState({
      score: score
    });
  }

  setNextQuestion() {
    const questionNumber = this.state.questionNumber + 1;

    // preload quesion image of question after the next one, if not at the end
    if( this.state.questionNumber+1 < this.quizQuestions.length){
      this.preloadQuestionImage( this.state.questionNumber+1 );
    }

    this.setState({
      questionNumber: questionNumber,
      questionIntro: this.quizQuestions[questionNumber-1].questionIntro,
      questionType: this.quizQuestions[questionNumber-1].questionType,
      subQuestions: this.quizQuestions[questionNumber-1].subQuestions,
      disableAnswerButtons: false,
      userAnswers: ['', '', ''],
      userAnswersCorrect: [null, null, null],
      answerTimerStart: new Date().getTime()
    });

    ReactGA.pageview( '/' + this.state.questionIntro);
  }

  setResult(result) {
    this.setState({ screen: 'result' });
  }

  handleClickContinue(event) {
    // check all answers for correct ones
    let addToScore = 0;
    let tempUserAnswerCorrect = [];
    this.state.userAnswers.forEach( (userAnswer, index) => {
      if(userAnswer === this.quizQuestions[this.state.questionNumber-1].subQuestions[index].subAnswer) {
        addToScore++;
        tempUserAnswerCorrect[index] = true;
      } else {
        tempUserAnswerCorrect[index] = false;
      }
    });
    this.increaseScore( addToScore );

    // display correct and incorrect answers
    this.setState( {
      userAnswersCorrect: tempUserAnswerCorrect,
      disableAnswerButtons: true,
    } );

    // calculate user answer time
    const answerTimerEnd = new Date().getTime();
    const answerTime = answerTimerEnd - this.state.answerTimerStart;

    ReactGA.event({
      category: 'User',
      action: 'Answered question',
      label: this.state.questionIntro.toString(),
      value: answerTime
    });

    ReactGA.timing({
      category: 'User',
      variable: 'Answered question',
      value: answerTime,
      label: this.state.questionIntro.toString()
    });

    // determine next screen
    if (this.state.questionNumber < this.quizQuestions.length) {
      setTimeout(() => this.setNextQuestion(), 900);
    } else {
      setTimeout(() => this.setResult(), 900);
    }
  }

  handleClickStart(event) {
    ReactGA.event({
      category: 'User',
      action: 'Quiz started'
    });

    this.setState({
      screen: 'question',
      answerTimerStart: new Date().getTime()
    });

    this.preloadQuestionImage( this.state.questionNumber );
  }

  handleClickRestart(event) {
    ReactGA.event({
      category: 'User',
      action: 'Quiz restarted'
    });

    this.setState({
      questionNumber: 1,
      questionIntro: this.quizQuestions[0].questionIntro,
      questionType: this.quizQuestions[0].questionType,
      subQuestions: this.quizQuestions[0].subQuestions,
      disableAnswerButtons: false,
      userAnswers: ['', '', ''],
      userAnswersCorrect: [null, null, null],
      score: 0,
      screen: 'question',
      answerTimerStart: new Date().getTime()
    });
  }

  preloadQuestionImage( questionNumber ){
    const preloadCategoryImage = new Image();
    preloadCategoryImage.src = `./images/category-image-${this.quizQuestions[questionNumber].questionType.toLowerCase()}.png`;
  }

  renderStart() {
    return (
      <Start onClickStart={this.handleClickStart} strings={this.quizStrings} />
    );
  }

  renderQuiz() {
    return (
      <Quiz
        disableAnswerButtons={this.state.disableAnswerButtons}
        userAnswers={this.state.userAnswers}
        userAnswersCorrect={this.state.userAnswersCorrect}
        answerOptions={this.state.answerOptions}
        subQuestions={this.state.subQuestions}
        questionNumber={this.state.questionNumber}
        questionIntro={this.state.questionIntro}
        questionType={this.state.questionType}
        score={this.state.score}
        onAnswerSelected={this.handleAnswerSelected}
        onClickContinue={this.handleClickContinue}
        disableContinue={this.state.userAnswers.includes('')}
        strings={this.quizStrings}
      />
    );
  }

  renderResult() {
    return (
      <Result
        score={this.state.score}
        totalQuestions={this.quizQuestions.length * this.quizQuestions[0].subQuestions.length}
        onClickRestart={this.handleClickRestart}
        onClickShareFacebook={this.handleClickShareFacebook}
        onClickShareTwitter={this.handleClickShareTwitter}
        strings={this.quizStrings}
      />
    );
  }

  showScreen(){
    if( this.state.screen === 'start' )    return this.renderStart();
    if( this.state.screen === 'question' ) return this.renderQuiz();
    if( this.state.screen === 'result' )   return this.renderResult();
  }

  render() {

    const loadingIndicator = (
      <ReactCSSTransitionGroup
        component="div"
        transitionName="fade"
        transitionEnterTimeout={800}
        transitionLeaveTimeout={500}
        transitionAppear
        transitionAppearTimeout={500}
      >
        <div className="app state__loading">
          <div className="app__wrapper">
            <img src={loadinggif} alt="" className="state__loading-image" />
          </div>
        </div>
      </ReactCSSTransitionGroup>
    );

    let preloadImages = [
      './images/logo-tagline.png',
      './images/background_start_desktop.jpg',
      './images/background_quiz.jpg'
    ];

    if( windowWidth >= bgSwitchBreakpoint) {
      preloadImages = [ // eslint-disable-line no-unused-vars
        './images/logo-tagline.png',
        './images/background_start_desktop.jpg',
        './images/background_quiz_desktop.jpg'
      ];
    }

    return (
      <Preload
        loadingIndicator={loadingIndicator}
        images={preloadImages}
        autoResolveDelay={3000}
        onError={this._handleImageLoadError}
        onSuccess={this._handleImageLoadSuccess}
        resolveOnError={true}
        mountChildren={true}
        >
        <ReactCSSTransitionGroup
          component="div"
          transitionName="fade"
          transitionEnterTimeout={800}
          transitionLeaveTimeout={500}
          transitionAppear={true}
          transitionAppearTimeout={500}
        >
          <div className={"app state__" + this.state.screen}>
            <div className="app__wrapper">
              { this.showScreen() }
            </div>
          </div>
        </ReactCSSTransitionGroup>
      </Preload>
    );
  }

}

export default App;


/** WEBPACK FOOTER **
 ** ./src/App.js
 **/